import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { notification } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { updateGlobalAlert } from "../../redux/home/homeSlice";
// INTERFACES
import { RootState } from "../../app/store";

function GlobalAlert() {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const dispatch = useDispatch();
  const [t] = useTranslation("global");
  const { globalAlert } = useSelector((state: any) => state.home);

  type NotificationType = "success" | "info" | "warning" | "error";

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const { theme, userLogged } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const launchNotification = (title: string, text: any, status: NotificationType) => {
    let description = text;
    if (title === "Error") {
      if (text && text.data && text.data.message) {
        description = text.data.message;
      } else {
        description = t("sideBar.users");
      }
    }
    if (userLogged.globalNotifications) {
      notification[status]({
        message: title,
        description,
        placement: "top",
        className: `monitoring__notification__${theme}`,
      });
    }

    // clean alert
    dispatch(
      updateGlobalAlert({
        title: "",
        description: "",
        status: "",
      }),
    );
  };
  // ************************************************* */
  // USE EFFECT ************************************** */
  // GLOBAL ALERT
  useEffect(() => {
    if (globalAlert && globalAlert.title && globalAlert.description && globalAlert.status) {
      launchNotification(globalAlert.title, globalAlert.description, globalAlert.status);
    }
  }, [globalAlert]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <div id="global-alert" />
    </div>
  );
}

export default GlobalAlert;
